"use client";

import { useClerk } from "@clerk/nextjs";
import { usePathname } from "next/navigation";

export const useSetAuthModalOpen = () => {
  const clerk = useClerk();
  const pathnameForClerk = usePathname();

  return () =>
    clerk.openSignIn({
      signUpForceRedirectUrl: `${pathnameForClerk}?signedup=true`,
      // @ts-expect-error: For some reason, Clerk's types don't include the signUpForceRedirectUrl property
      signInForceRedirectUrl: pathnameForClerk,
      forceRedirectUrl: pathnameForClerk,
    });
};
